module.exports = __webpack_public_path__ + "img/icon_excel.89ea80af.svg";